export default __webpack_public_path__ + "static/media/ODToroOpen.a0b2d187.jpg";